// extracted by mini-css-extract-plugin
module.exports =  {"rating-container":"uWALb2H","ratingContainer":"uWALb2H","rating":"nIyFSx1","score":"UMDJ6QC","star":"P1vp5wK","count":"k3iP67W"};